export const CLAROPAY_OPEN_ACCOUNT =
  "https://claropay.sng.link/Airav/iadw/hj8k";

export const PROMOTIONS_LINK_ES =
  "https://s3.us-west-1.amazonaws.com/sendola.io/sendolapay/Tabla+de+Promociones-+Claro+Pay.pdf";
export const PROMOTIONS_LINK_EN =
  "https://s3.us-west-1.amazonaws.com/sendola.io/sendolapay/Tabla+de+Promociones-+Claro+Pay+(English).pdf";
